export var SeekResultType;
(function (SeekResultType) {
    SeekResultType["ALLOWED"] = "ALLOWED";
    SeekResultType["FORWARD_SEEKING_NOT_ALLOWED"] = "FORWARD_SEEKING_NOT_ALLOWED";
    SeekResultType["GT12_ALLOWED"] = "GT12_ALLOWED";
    SeekResultType["GT12_SEEK_TO_ADBREAK"] = "GT12_SEEK_TO_ADBREAK";
    SeekResultType["GT12_SEEK_TO_AND_DISPLAY_ADBREAK"] = "GT12_SEEK_TO_AND_DISPLAY_ADBREAK";
    SeekResultType["GT12_FORBIDDEN"] = "GT12_FORBIDDEN";
    SeekResultType["STREAM_CHANGE"] = "STREAM_CHANGE";
})(SeekResultType || (SeekResultType = {}));
